import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LabelTypeEnum } from '../p-status-main-label';

@Component({
    selector: 'p-status-sub-label',
    template: `
        <div class="p-label-small">
            <span
                class="p-label-small-indicator"
                [ngClass]="[cssClass, 'p-label-small-indicator-' + type]"
                attr.aria-label="{{ ariaLabel }}"
            ></span>
            <span class="p-label-small-text p-paragraph-3 p-tpgr-semibold">{{ label }}</span>
        </div>
    `,
    styleUrls: ['./p-status-sub-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PStatusSubLabelComponent implements OnInit {
    @Input() label: string = '';
    @Input() ariaLabel: string = ''; // required if there is no label
    @Input() type: LabelTypeEnum | undefined = LabelTypeEnum.YELLOW;
    @Input() cssClass: string = '';

    constructor() {}

    ngOnInit(): void {}
}
